import React, { memo } from 'react'

const InputSelect = ({ value, changeValue, options }) => {
    return (
        <select
            className='form-select text-sm'
            value={value}
            onChange={e => changeValue(e.target.value)}
            style={{ outline: 'none' }}
        >
            <option value='/'>--Fliter select--</option>
            {options?.map(el => (
                <option key={el.id} value={el.value}>{el.text}</option>
            ))}
        </select>
    )
}

export default memo(InputSelect) 
